<template>
  <div class="row">
    <div class="col">
      <h2>Thank You For Applying!</h2>
      <p>You have successfully applied to the SIGGRAPH Student Volunteer Program.</p>
      <h3>Notification of Acceptance</h3>
      <p>Based on which application you submitted, you should hear from us around the following times:</p>
      <h3>Team Leader Applications</h3>
      <p><strong>February 2024</strong></p>
      <h3>Student Volunteer Applications</h3>
      <p><strong>May 2024</strong></p>
    </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  name: 'ThankYou',
  data () {
    return {}
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (!this.$store.state.application.completed) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/application/ThankYou.vue